import { cn } from "../../lib/utils";

function tier(score, invert) {
  const s = invert ? 100 - score : score;
  if (s <= 40) return { color: "#EF4444", ring: "text-red-400" };
  if (s <= 60) return { color: "#F97316", ring: "text-orange-400" };
  if (s <= 80) return { color: "#06B6D4", ring: "text-cyan-400" };
  return { color: "#10B981", ring: "text-emerald-400" };
}

export function ScoreCard({ score = 0, max = 100, title, subtitle, category, invert = false, size = 150, className, testId }) {
  const pct = Math.max(0, Math.min(1, score / max));
  const r = size / 2 - 12;
  const c = 2 * Math.PI * r;
  const t = tier(score, invert);

  return (
    <div className={cn("card-arch p-6 sm:p-7", className)} data-testid={testId}>
      <div className="halo" />
      <div className="relative flex flex-col items-center">
        {title && <p className="mono-label text-slate-400 mb-4 text-center">{title}</p>}
        <div className="relative" style={{ width: size, height: size }}>
          <svg width={size} height={size} className="-rotate-90">
            <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="10" />
            <circle
              cx={size / 2} cy={size / 2} r={r} fill="none" stroke={t.color} strokeWidth="10"
              strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c * (1 - pct)}
              style={{ transition: "stroke-dashoffset 1.1s cubic-bezier(.2,.7,.2,1)" }}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="font-head text-4xl font-extrabold text-white" style={{ color: t.color }}>{score}</span>
            <span className="text-xs text-slate-500 font-mono">/ {max}</span>
          </div>
        </div>
        {category && <p className={cn("mt-4 text-sm font-semibold", t.ring)}>{category}</p>}
        {subtitle && <p className="mt-1 text-xs text-slate-400 text-center">{subtitle}</p>}
      </div>
    </div>
  );
}

export function MiniScore({ label, value, suffix = "", tone = "amber", testId }) {
  const tones = {
    amber: "text-amber-400", cyan: "text-cyan-400", red: "text-red-400",
    emerald: "text-emerald-400", slate: "text-slate-200",
  };
  return (
    <div className="card-arch p-5" data-testid={testId}>
      <p className="mono-label text-slate-400">{label}</p>
      <p className={cn("mt-2 font-head text-3xl font-extrabold", tones[tone])}>{value}{suffix}</p>
    </div>
  );
}
